import { KPI_COLS } from './dashboardWidgetPresets';

export const ACCOUNT_360_STANDARD_TEMPLATE_ID = 'account360_standard';

const KPI_ROW = {
  id: 'kpi_row',
  rowType: 'kpi',
  layout: 'kpi-grid',
  cols: KPI_COLS(4),
};

const CHARTS_ROW = {
  id: 'charts_row',
  rowType: 'chart',
  layout: 'chart-grid',
  cols: [
    { id: 'chart_0', col: 'col-6', slotKey: 'chart_0', slotType: 'chart' },
    { id: 'chart_1', col: 'col-6', slotKey: 'chart_1', slotType: 'chart' },
    // { id: 'chart_2', col: 'col-6', slotKey: 'chart_2', slotType: 'chart' },
    // { id: 'chart_3', col: 'col-6', slotKey: 'chart_3', slotType: 'chart' },
  ],
};

const TABLE_ROW = {
  id: 'table_row',
  rowType: 'table',
  cols: [
    {
      id: 'dynamic_reports',
      col: 'col-12',
      slotKey: 'dynamic_reports',
      slotType: 'table',
    },
  ],
};

export const ACCOUNT_360_STANDARD_LAYOUT = {
  id: ACCOUNT_360_STANDARD_TEMPLATE_ID,
  name: 'Account 360 standard',
  description: 'KPI cards, two-column charts, and reports table.',
  icon: 'fa-th-large',
  previewVariant: 'template_standard',
  rows: [KPI_ROW, CHARTS_ROW, TABLE_ROW],
};

export const getAccount360TemplateById = (id) => {
  if (id === ACCOUNT_360_STANDARD_TEMPLATE_ID) {
    return ACCOUNT_360_STANDARD_LAYOUT;
  }
  return null;
};
